import React from 'react'
import { Field, FieldArray, FieldProps } from 'formik'
import { useServiceContext } from '../../../../../root'
import { WF_STEP_TYPE } from './constants'
import UserGroupSteps from './UserGroupSteps'
import ApprovalEventActions from './ApprovalEventActions'

interface ApprovalStepFormProps {
  values: any
  setFieldValue: (field: string, value: any) => void
}

const ApprovalStepForm: React.FC<ApprovalStepFormProps> = ({ values, setFieldValue }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const approversType = values.approvers?.type || WF_STEP_TYPE.NOT_DEFINED

  return (
    <>
      <div className="form-group">
        <label className="control-label">{translate('BROWSER_FILE_SETTINGS_APPROVERS_APPROVAL_TYPE_HEADLINE')}</label>
        <Field name="approvers.type">
          {({ field }: FieldProps) => (
            <>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`93460996-3726-4cc6-b695-8b59ca85c8ab-${WF_STEP_TYPE.NOT_DEFINED}`}
                    value={WF_STEP_TYPE.NOT_DEFINED}
                    checked={approversType === WF_STEP_TYPE.NOT_DEFINED}
                    onChange={() => setFieldValue('approvers.type', WF_STEP_TYPE.NOT_DEFINED)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_APPROVERS_LABEL_NOT_DEFINED')}
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`93460996-3726-4cc6-b695-8b59ca85c8ab-${WF_STEP_TYPE.SETUP_WITH_WORKFLOW}`}
                    value={WF_STEP_TYPE.SETUP_WITH_WORKFLOW}
                    checked={approversType === WF_STEP_TYPE.SETUP_WITH_WORKFLOW}
                    onChange={() => setFieldValue('approvers.type', WF_STEP_TYPE.SETUP_WITH_WORKFLOW)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_APPROVERS_LABEL_SETUP_APPROVERS_WITH_CR')}
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`93460996-3726-4cc6-b695-8b59ca85c8ab-${WF_STEP_TYPE.USE_PREDEFINED}`}
                    value={WF_STEP_TYPE.USE_PREDEFINED}
                    checked={approversType === WF_STEP_TYPE.USE_PREDEFINED}
                    onChange={() => setFieldValue('approvers.type', WF_STEP_TYPE.USE_PREDEFINED)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_APPROVERS_LABEL_USE_PREDEFINED')}
                </label>
              </div>
            </>
          )}
        </Field>
      </div>

      {/* Show UserGroupSteps when USE_PREDEFINED is selected */}
      {approversType === WF_STEP_TYPE.USE_PREDEFINED && (
        <UserGroupSteps
          name="approvers.steps"
          values={values.approvers?.steps || []}
          labelTxt={'BROWSER_FILE_SETTINGS_APPROVERS_APPROVAL_SEQUENCE_HEADLINE'}
          nofallTxt={'BROWSER_FILE_SETTINGS_APPROVERS_INFO_LABEL'}
        />
      )}

      {/* Approval Events Section */}
      <div className="form-group">
        <label className="control-label">{translate('BROWSER_FILE_SETTINGS_APPROVERS_APPROVAL_EVENTS_HEADLINE')}</label>
        <ApprovalEventActions name="approvers.approveActions" values={values.approvers?.approveActions || []} />
      </div>
    </>
  )
}

export default ApprovalStepForm
